import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1510.854 1779.583l328.006-328.007 81.14 81.37-361.566 361.566H361.566L0 1532.946l81.255-81.37 327.891 328.007h1101.708zM962.334 25l500.284 500.285-81.14 81.37-361.795-361.681v1187.559H904.869V244.973L543.188 606.655l-81.14-81.37L962.333 25z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconUploadLine = /*#__PURE__*/function (_Component) {
  _inherits(IconUploadLine, _Component);

  var _super = _createSuper(IconUploadLine);

  function IconUploadLine() {
    _classCallCheck(this, IconUploadLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconUploadLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconUpload",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconUploadLine.displayName = "IconUploadLine";
  return IconUploadLine;
}(Component);

IconUploadLine.glyphName = 'upload';
IconUploadLine.variant = 'Line';
IconUploadLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconUploadLine;
export { IconUploadLine };